import * as React from "react";
import { Spinner } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
/* empty css                                 */
const ProductBlockContainerLoader = () => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement("div", { className: "product-block-container-loader" }, /* @__PURE__ */ React.createElement(Spinner, { "aria-label": getLabel("common.loadingText") }));
};
export {
  ProductBlockContainerLoader
};
//# sourceMappingURL=ProductBlockContainerLoader.js.map
